import React from "react";

const CancellationAndRefundPolicy = () => {
    return (
        <div className='container mt-3'>

            <div className="row mb-4">
                <div className="col-md-12 mt-4 mb-2">
                    <h1 className='text-center mb-3 h1 fw-bold'>Cancellation and Refund Policy</h1>
                </div>
                <div className="shadow-sm p-4 pb-2 border rounded-3 bg-white">
                    <div className="row align-items-center ">

                        <p>At Exim Multimedia LLP, we strive to provide the best possible experience for our Dcopy subscribers. However, we understand that circumstances may arise where you need to cancel your subscription. This policy outlines the procedures for cancellation and refund.</p>

                        <h5 className="fw-bolder">Cancellation</h5>

                        <p>1. Cancellation by Subscriber: You may cancel your subscription at any time by logging into your account and selecting the "Cancel Subscription" option. Alternatively, you may contact our customer support team via phone, email, or chat to request cancellation.</p>

                        <p>2. Cancellation by EXIM Multimedia LLP: We reserve the right to cancel your subscription at any time without notice if we believe you have breached our Terms and Conditions or if we are required to do so by law.</p>

                        <h5 className="fw-bolder">Refund</h5>

                        <p>1. Refund Eligibility: You are eligible for a refund if you cancel your subscription within 07 days of the initial subscription date or within 14 days of the renewal date.</p>

                        <p>2. Refund Amount: Edition Amount Subscribed</p>

                        <p>3. Refund Method: Refunds will be processed through the original payment method.</p>

                        <p>4. Refund Processing Time: Approved refunds will be processed within 5–7 working days from the date of approval.</p>

                        <p>By subscribing to our ePaper, you acknowledge that you have read, understood, and agree to be bound by this Cancellation and Refund Policy.</p>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default CancellationAndRefundPolicy;